export const BRAND = {
  name: 'EpiSplain',
  headline: 'EpiSplain: Epidemiology Made Clear',
  subheadline: 'An interactive platform for understanding disease patterns, risk factors, and public health outcomes through real data and clear explanations.',
  logoUrl: 'https://customer-assets.emergentagent.com/job_episplain-learn/artifacts/gybmz6e0_Untitled%20design%20-%202026-03-26T192716.466.png',
  mission: 'We turn complex epidemiologic data into actionable insights that help you understand disease patterns and make informed health decisions.',
};

export const EPIDEMIOLOGY_CORE = {
  what: 'Epidemiology is the study of how diseases spread, who they affect, and why. It answers questions like: Who is most at risk? What causes outbreaks? How can we prevent disease?',
  why: 'Understanding disease patterns helps communities prevent outbreaks, target resources effectively, and save lives through evidence-based public health decisions.',
  how: 'Epidemiologists analyze data from surveys, health records, and surveillance systems to identify trends, risk factors, and effective interventions.',
};

export const REAL_WORLD_APPLICATIONS = [
  {
    title: 'Disease Surveillance',
    description: 'Track disease outbreaks in real-time to detect and respond before they spread',
    icon: 'radar',
    example: 'CDC monitors 120+ conditions nationally through systems like BRFSS',
  },
  {
    title: 'Outbreak Investigation',
    description: 'Identify sources of disease clusters and implement targeted interventions',
    icon: 'search',
    example: '2019 measles outbreak traced to undervaccinated communities',
  },
  {
    title: 'Study Design',
    description: 'Design rigorous studies to establish causation and test interventions',
    icon: 'clipboard',
    example: 'Randomized trials proved COVID vaccines are safe and effective',
  },
  {
    title: 'Risk Assessment',
    description: 'Quantify how behaviors, exposures, and genetics affect disease risk',
    icon: 'chart',
    example: 'Smoking increases lung cancer risk 15-30x compared to non-smokers',
  },
];

export const WHAT_THIS_SITE_DOES = [
  {
    title: 'Visualizes Disease Data',
    body: 'Interactive maps, charts, and dashboards showing real CDC data on chronic diseases, vaccines, and health outcomes.',
    emoji: '📊',
  },
  {
    title: 'Explains Epidemiologic Concepts',
    body: 'Learn about prevalence, incidence, risk factors, bias, and study design through clear examples.',
    emoji: '🧠',
  },
  {
    title: 'Connects Data to Action',
    body: 'Every chart answers: what am I seeing, why does it matter, and what can I do about it?',
    emoji: '🎯',
  },
];

export const KEY_METRICS = {
  chronicPrevalence: { value: 60, label: '% of US adults with chronic disease', trend: 'increasing' },
  preventable: { value: 80, label: '% of chronic disease that is preventable', trend: 'stable' },
  annualCost: { value: 4.1, label: 'Trillion dollars annual cost', trend: 'increasing' },
  vaccinesSaved: { value: 4, label: 'Million lives saved by vaccines/year globally', trend: 'stable' },
};
